module.exports = __webpack_public_path__ + "static/media/ic-nav-event-schedule.febfd7b1.svg";